/*
 * combined-listings.js
 * ----------------------------------------------------------------------------
 * Progressive-enhancement widget for the Combined Listings option picker
 * (snippets/product-option-picker.liquid). PDP only.
 *
 * Selection is plain navigation: every Scent row and Size pill is a real <a href>
 * (data-no-instant => clean full page load). There is NO AJAX swap and nothing to
 * re-initialise — which is what makes it robust in this theme.
 *
 * This script powers ONLY the dropdown disclosure UX: open/close, roving-tabindex
 * keyboard nav, type-ahead, and click-outside. Each option row is itself the
 * focusable <a>, so Enter navigates natively. With JS off (no `.js` on <html>)
 * the panel stays visible via CSS and the links remain usable.
 */
(function () {
  'use strict';

  var OPTIONS_SELECTOR = '[data-cl-options]';
  var bound = false;
  var typeAheadBuffer = '';
  var typeAheadTimer = null;

  function getSelect(el) {
    return el && el.closest ? el.closest('[data-cl-select]') : null;
  }

  function optionList(panel) {
    return Array.prototype.slice.call(panel.querySelectorAll('[data-cl-option]'));
  }

  function setOpen(select, open) {
    var trigger = select.querySelector('[data-cl-trigger]');
    var panel = select.querySelector('[data-cl-panel]');
    if (!trigger || !panel) return;

    if (open) {
      closeAll(select);
      select.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      // Panel becomes visible via CSS (.cl-select.is-open); now focus a row.
      var active = panel.querySelector('[aria-current="true"]') || panel.querySelector('[data-cl-option]');
      if (active) focusOption(panel, active);
    } else {
      select.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      optionList(panel).forEach(function (o) { o.tabIndex = -1; });
    }
  }

  function closeAll(except) {
    document.querySelectorAll('[data-cl-select].is-open').forEach(function (sel) {
      if (sel !== except) setOpen(sel, false);
    });
  }

  function focusOption(panel, option) {
    optionList(panel).forEach(function (o) { o.tabIndex = -1; });
    option.tabIndex = 0;
    option.focus();
  }

  function moveFocus(panel, current, where) {
    var list = optionList(panel);
    if (!list.length) return;
    var idx = list.indexOf(current);
    var next;
    if (where === 'first') next = 0;
    else if (where === 'last') next = list.length - 1;
    else {
      if (idx < 0) idx = 0;
      next = (idx + where + list.length) % list.length;
    }
    focusOption(panel, list[next]);
  }

  function typeAhead(panel, char) {
    if (typeAheadTimer) clearTimeout(typeAheadTimer);
    typeAheadBuffer += char.toLowerCase();
    typeAheadTimer = setTimeout(function () { typeAheadBuffer = ''; }, 500);

    var match = optionList(panel).find(function (o) {
      return (o.getAttribute('data-value') || '').toLowerCase().indexOf(typeAheadBuffer) === 0;
    });
    if (match) focusOption(panel, match);
  }

  /* --------------------------------------------------------- event handlers */

  function onClick(e) {
    var trigger = e.target.closest('[data-cl-trigger]');
    if (trigger) {
      var select = getSelect(trigger);
      setOpen(select, !select.classList.contains('is-open'));
      return;
    }
    // A click on a row navigates natively (it's a real <a>); a click anywhere
    // outside an open dropdown closes it.
    if (!getSelect(e.target)) closeAll();
  }

  function onKeydown(e) {
    var trigger = e.target.closest('[data-cl-trigger]');
    if (trigger) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        var sel = getSelect(trigger);
        setOpen(sel, true);
        if (e.key === 'ArrowUp') {
          var panelUp = sel.querySelector('[data-cl-panel]');
          var list = optionList(panelUp);
          if (list.length) focusOption(panelUp, list[list.length - 1]);
        }
      }
      return;
    }

    var option = e.target.closest('[data-cl-option]');
    if (!option) return;
    var panel = option.closest('[data-cl-panel]');
    var select = getSelect(option);

    switch (e.key) {
      case 'ArrowDown': e.preventDefault(); moveFocus(panel, option, 1); break;
      case 'ArrowUp': e.preventDefault(); moveFocus(panel, option, -1); break;
      case 'Home': e.preventDefault(); moveFocus(panel, option, 'first'); break;
      case 'End': e.preventDefault(); moveFocus(panel, option, 'last'); break;
      case 'Escape':
        e.preventDefault();
        setOpen(select, false);
        select.querySelector('[data-cl-trigger]').focus();
        break;
      case 'Tab':
        setOpen(select, false);
        break;
      case ' ':
      case 'Spacebar':
        // Space isn't a default activation for links; navigate explicitly.
        e.preventDefault();
        option.click();
        break;
      // Enter: the option IS the focused <a>, so the browser navigates natively.
      default:
        if (e.key && e.key.length === 1 && /\S/.test(e.key)) typeAhead(panel, e.key);
    }
  }

  function init() {
    if (!document.querySelector(OPTIONS_SELECTOR)) return;
    if (bound) return;
    bound = true;
    document.addEventListener('click', onClick);
    document.addEventListener('keydown', onKeydown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.CombinedListings = { init: init };
})();
